import React from 'react';
import { Card } from './ui/Card';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  quote: 'El Sistema PRO cambió por completo mi forma de trabajar. Antes armaba cada ficha desde cero y perdía casi una hora por paciente nuevo. Ahora tengo todo listo: solo completo los campos y paso a la evaluación. Totalmente recomendado para cualquier podólogo que quiera trabajar con orden.',
  author: 'V. R.',
  role: 'Podóloga',
  location: 'Consultorio privado, CABA'
}, {
  id: 2,
  quote: 'Lo que más valoro es el módulo de pie diabético. Tener el protocolo de seguimiento, el test de monofilamento y las alertas clínicas en una sola hoja me dio una seguridad que antes no tenía. Mis pacientes diabéticos lo notan.',
  author: 'M. D.',
  role: 'Podólogo',
  location: 'Centro de salud, Rosario'
}, {
  id: 3,
  quote: 'Los consentimientos informados solos ya valen lo que pagué. Siempre supe que debía tenerlos pero nunca encontraba el tiempo para armarlos. El Tomo 5 está adaptado a la legislación argentina y listo para firmar desde el primer día.',
  author: 'L. P.',
  role: 'Podóloga',
  location: 'Atención domiciliaria, GBA'
}, {
  id: 4,
  quote: 'Desde que uso el Sistema PRO, mis pacientes notan la diferencia. Todo está organizado, profesional y listo. Lo mejor que invertí este año.',
  author: 'S. M.',
  role: 'Podóloga, 34 años',
  location: 'Córdoba'
}, {
  id: 5,
  quote: 'Los scripts de WhatsApp me salvaron. Antes se me caían 3 o 4 turnos por semana. Ahora casi no tengo ausencias.',
  author: 'R. A.',
  role: 'Podólogo, 41 años',
  location: 'Mendoza'
}, {
  id: 6,
  quote: 'Empecé a usar las fichas de evaluación y mis informes de derivación quedaron impecables. Los médicos me responden distinto ahora.',
  author: 'A. C.',
  role: 'Podóloga, 29 años',
  location: 'La Plata'
}, {
  id: 7,
  quote: 'Tenía miedo de no saber usarlo, pero el Kit de 30 minutos me dejó todo armado en una tarde. Muy práctico.',
  author: 'G. T.',
  role: 'Podólogo, 52 años',
  location: 'Tucumán'
}, {
  id: 8,
  quote: 'Las tarjetas de cuidados para pacientes son un golazo. Les entrego una al final de cada sesión y noto que siguen mejor las indicaciones.',
  author: 'N. B.',
  role: 'Podóloga, 37 años',
  location: 'Rosario'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-slate-50" data-id="element-277">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-278">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-279">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-6" data-id="element-280">
            Lo que dicen los podólogos que ya usan el Sistema PRO
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-281">
          {testimonials.map(testimonial => <Card key={testimonial.id} className="p-6 flex flex-col h-full bg-white" data-id="element-282">
              <div className="flex gap-1 mb-4" data-id="element-283">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-284" />)}
              </div>
              <blockquote className="text-slate-700 flex-grow mb-6 italic" data-id="element-285">
                "{testimonial.quote}"
              </blockquote>
              <div className="mt-auto pt-4 border-t border-slate-100" data-id="element-286">
                <p className="font-bold text-slate-900" data-id="element-287">{testimonial.author}</p>
                <p className="text-sm text-slate-500" data-id="element-288">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}